var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VendorSignupStripe",style:({ height: _vm.wraperHeight })},[_c('div',{ref:"container",attrs:{"id":"container"}}),(_vm.showError)?_c('div',[_vm._v("Something went wrong!")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }